(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection_menu_nudges"] && !Shopify.designMode) return;
  try {
    (function () {
    let retryCount = 0;
    const maxRetries = 50; // Maximum 5 seconds (50 * 100ms)

    function initSwiper() {
      const swiperContainer = document.querySelector('.collection-menu-nudges__swiper');
      if (!swiperContainer) {
        // Container not found, retry if we haven't exceeded max retries
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(initSwiper, 100);
        }
        return;
      }

      // Check if Swiper is already initialized on this container
      if (swiperContainer.swiper) {
        return;
      }

      if (typeof Swiper === 'undefined') {
        // Retry after a short delay if Swiper is not loaded yet
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(initSwiper, 100);
        }
        return;
      }

      // Find index of the active slide so we can start with it in view
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      let initialSlideIndex = 0;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('active')) {
          initialSlideIndex = i;
          break;
        }
      }

      try {
        new Swiper('.collection-menu-nudges__swiper', {
          slidesPerView: 'auto',
          slidesPerGroupSkip: 10,
          spaceBetween: 0,
          initialSlide: initialSlideIndex - 1,
          navigation: {
            nextEl: '.collection-menu-nudges__swiper-button-next',
            prevEl: '.collection-menu-nudges__swiper-button-prev',
          },
          breakpoints: {
            320: {
              spaceBetween: 0,
            },
            750: {
              spaceBetween: 0,
            },
          },
        });
      } catch (error) {
        console.error('Error initializing Swiper:', error);
        // Retry after a delay if initialization fails
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(initSwiper, 200);
        }
      }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwiper);
    } else {
      // DOM is already ready, try to initialize
      initSwiper();
    }

    // Find the Sub Category filter container
    function findSubCategoryFilter() {
      const filterLabels = document.querySelectorAll('.facets__label.h6');
      for (let label of filterLabels) {
        const labelText = label.textContent.trim().toLowerCase();
        if (labelText === 'sub category' || labelText.includes('sub category')) {
          return label.closest('.facets__item');
        }
      }
      return null;
    }

    // Find matching checkbox for a given pill text
    function findMatchingCheckbox(subCategoryFilter, pillText) {
      if (!subCategoryFilter) return null;

      const checkboxes = subCategoryFilter.querySelectorAll('input[type="checkbox"]');

      for (let checkbox of checkboxes) {
        // First check data-label attribute (most reliable)
        if (checkbox.dataset.label) {
          if (checkbox.dataset.label.trim().toLowerCase() === pillText.toLowerCase()) {
            return checkbox;
          }
        }

        // Get the associated label element
        let label = null;

        // Try different methods to find the label
        if (checkbox.id) {
          label = document.querySelector(`label[for="${checkbox.id}"]`);
        }

        if (!label) {
          // Check for pill label
          label = checkbox.closest('.facets__pill-wrapper')?.querySelector('.facets__pill-label');
        }

        if (!label) {
          // Check for regular label in list item
          label = checkbox.closest('li')?.querySelector('label, .facets__image-label, .facets__swatch-label');
        }

        if (!label) {
          // Check for label as parent
          label = checkbox.closest('label');
        }

        if (label) {
          const labelText = label.textContent.trim();
          // Check for exact match first, then partial match
          if (labelText.toLowerCase() === pillText.toLowerCase()) {
            return checkbox;
          } else if (
            labelText.toLowerCase().includes(pillText.toLowerCase()) ||
            pillText.toLowerCase().includes(labelText.toLowerCase())
          ) {
            // Use partial match as fallback (but continue searching for exact match)
            if (!checkbox.checked) {
              continue;
            }
          }
        }

        // Also check aria-label attribute
        if (checkbox.getAttribute('aria-label')) {
          const ariaLabel = checkbox.getAttribute('aria-label').trim().toLowerCase();
          if (ariaLabel === pillText.toLowerCase()) {
            return checkbox;
          }
        }
      }
      return null;
    }

    // Sync all pill active states with filter checkboxes
    function syncPillActiveStates() {
      const subCategoryFilter = findSubCategoryFilter();
      if (!subCategoryFilter) return;

      // Ensure the filter details is open to access checkboxes
      const detailsElement = subCategoryFilter.querySelector('details');
      if (detailsElement && !detailsElement.open) {
        detailsElement.open = true;
      }

      const filterCheckboxes = subCategoryFilter.querySelectorAll('input[type="checkbox"]');
      const hasFilters = filterCheckboxes.length > 0;

      // Get all pill buttons
      const pills = document.querySelectorAll('.collection-menu-nudges__pill');
      let anyChecked = false;
      let allPill = null;

      pills.forEach((pill) => {
        if (!hasFilters) {
          pill.classList.remove('active');
          pill.classList.add('is-disabled');
          return;
        }

        pill.classList.remove('is-disabled');
        const pillText = pill.textContent.trim();
        if (pillText.toLowerCase() === 'all') {
          allPill = pill;
          return;
        }
        const matchingCheckbox = findMatchingCheckbox(subCategoryFilter, pillText);

        if (matchingCheckbox) {
          // Sync active class with checkbox state
          if (matchingCheckbox.checked) {
            pill.classList.add('active');
            anyChecked = true;
          } else {
            pill.classList.remove('active');
          }
        } else {
          pill.classList.remove('active');
          pill.classList.add('is-disabled');
        }
      });

      if (allPill) {
        if (hasFilters) {
          if (anyChecked) {
            allPill.classList.remove('active');
          } else {
            allPill.classList.add('active');
          }
        } else {
          allPill.classList.remove('active');
          allPill.classList.add('is-disabled');
        }
      }
    }

    // Scroll the active pill into view within the pills horizontal scroll
    function scrollActivePillIntoView() {
      const activePill = document.querySelector('.collection-menu-nudges__pills-scroll .collection-menu-nudges__pill.active');
      if (activePill) {
        activePill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    // Sticky scroll behavior based on scroll direction with smooth transitions
    function initStickyScrollBehavior() {
      const collectionMenuNudges = document.querySelector('.collection-menu-nudges');
      const pillsWrapper = document.querySelector('.collection-menu-nudges__pills-wrapper');
      const categoriesWrapper = document.querySelector('.collection-menu-nudges__categories-wrapper');

      if (!collectionMenuNudges) return;

      // Only proceed if pills wrapper exists (third level items are present)
      if (!pillsWrapper) return;

      // Scroll active pill into view on load
      scrollActivePillIntoView();

      let lastScrollTop = 0;
      let ticking = false;
      let isTransitioning = false;
      const scrollThreshold = 5; // Minimum scroll distance to trigger direction change

      // Get the initial position of the collection menu nudges
      const getMenuTop = () => {
        const rect = collectionMenuNudges.getBoundingClientRect();
        return rect.top + window.pageYOffset;
      };

      let menuInitialTop = getMenuTop();

      // Recalculate on resize
      window.addEventListener('resize', () => {
        if (!pillsWrapper.classList.contains('is-sticky-scroll-down')) {
          menuInitialTop = getMenuTop();
        }
      });

      function handleScroll() {
        if (ticking || isTransitioning) return;

        ticking = true;
        requestAnimationFrame(() => {
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

          // Only process if scroll difference is significant and we've scrolled past the menu
          if (scrollDifference >= scrollThreshold && currentScrollTop >= menuInitialTop) {
            // Keep pills sticky when scrolling both down and up (as long as we're past the menu)
            if (!pillsWrapper.classList.contains('is-sticky-scroll-down')) {
              collectionMenuNudges.classList.add('hide-categories');
              pillsWrapper.classList.add('is-sticky-scroll-down');
            }
            
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
          } else if (currentScrollTop < menuInitialTop) {
            // Reset sticky states when above the menu
            if (pillsWrapper.classList.contains('is-sticky-scroll-down')) {
              isTransitioning = true;
              collectionMenuNudges.classList.remove('hide-categories');
              pillsWrapper.classList.remove('is-sticky-scroll-down');
              setTimeout(() => {
                isTransitioning = false;
              }, 300);
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
          }

          ticking = false;
        });
      }

      // Throttled scroll listener with passive flag for better performance
      window.addEventListener('scroll', handleScroll, { passive: true });

      // Initial check after a small delay to ensure layout is complete
      setTimeout(() => {
        handleScroll();
      }, 100);
    }

    // Initialize sticky scroll behavior
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyScrollBehavior);
    } else {
      initStickyScrollBehavior();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    let loginBtn = document.getElementById('header-login-button');
    if (!loginBtn) return;
    function enableLoginButton() {
      loginBtn.classList.remove('header-actions__login-button--until-load');
    }
    if (document.readyState === 'complete') {
      enableLoginButton();
    } else {
      window.addEventListener('load', enableLoginButton);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["login-popup"] && !Shopify.designMode) return;
  try {
    // Track name input field - first character entry
  (function () {
    let hasTrackedNameEntry = false;
    let isAttached = false;

    function attachNameInputTracking() {
      const nameInput = document.getElementById('userNameInput');
      const nameInputContent = document.getElementById('name-input-content');

      if (!nameInput || typeof trackLoginNameEntry !== 'function' || isAttached) {
        return;
      }

      isAttached = true;

      // Track first character entry using keydown event
      nameInput.addEventListener(
        'keydown',
        function (e) {
          if (!hasTrackedNameEntry) {
            // Check if current value is empty before the new character is added
            const currentValue = nameInput.value.trim();

            // Only track if input is empty (first character being entered)
            if (currentValue.length === 0) {
              // Check if it's a printable character (not control keys)
              const isPrintableChar = e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;

              if (isPrintableChar) {
                trackLoginNameEntry({
                  login_type: 'sign_up', // This is for new sign-ups entering name
                });
                hasTrackedNameEntry = true;
                console.log('🔵 [GTM] Name entry tracked - first character entered');
              }
            }
          }
        },
        { once: false }
      );

      // Also monitor when name input content becomes visible (for dynamically loaded content)
      if (nameInputContent) {
        const nameContentObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              const isVisible = nameInputContent.style.display !== 'none';
              if (isVisible && !isAttached) {
                // Re-attach if content becomes visible
                setTimeout(() => {
                  attachNameInputTracking();
                }, 100);
              }
            }
          });
        });

        nameContentObserver.observe(nameInputContent, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }
    }
    
    attachNameInputTracking();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-filter-sort-bar"] && !Shopify.designMode) return;
  try {
    function handleDialogClose(popup) {
    popup.style.display = 'none';
  }

  function resetPopup(popup) {
    popup.style.display = 'none';
    if (popup.refs?.dialog?.open) popup.closeDialog();
  }

  function initializeDialogs() {
    ['mobile-filter-popup', 'mobile-sort-popup'].forEach((selector) => {
      const dialog = document.querySelector(`${selector} dialog`);
      const popup = document.querySelector(selector);
      if (dialog?.hasAttribute('open')) dialog.removeAttribute('open');
      if (popup) popup.style.display = 'none';
    });
    Object.assign(document.body.style, { width: '', position: '', top: '' });
  }

  function handleDOMContentLoaded() {
    ['mobile-filter-popup', 'mobile-sort-popup'].forEach((selector) => {
      const popup = document.querySelector(selector);
      if (popup) resetPopup(popup);
    });
    Object.assign(document.body.style, { width: '', position: '', top: '' });
  }

  function resetFilterCheckboxes(popup) {
    const form = popup.querySelector('form');
    if (!form) return;
    form.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => (cb.checked = false));
    // Reset price filter inputs
    form.querySelectorAll('.mobile-price-facet__input').forEach((input) => (input.value = ''));
    const facetsForm = popup.querySelector('facets-form-component');
    if (facetsForm?.updateFilters) facetsForm.updateFilters();
  }

  function applyFilterChanges(popup) {
    const activeCategory = popup.querySelector('.mobile-filter-layout__category--active');
    const activeFilterIndex = activeCategory?.dataset.filterIndex || '0';
    popup.dataset.activeFilterIndex = activeFilterIndex;
    const sectionId = popup.closest('.shopify-section')?.id;

    // Store active filter index
    sessionStorage.setItem(`mobile-filter-active-index`, activeFilterIndex);

    // Store all filter information when filters are applied
    const form = popup.querySelector('form');
    if (form) {
      const formData = new FormData(form);
      const filterData = {
        activeFilterIndex: activeFilterIndex,
        filters: {},
        priceRange: {},
        sortBy: null,
      };

      // Collect all checked checkboxes
      const checkedInputs = form.querySelectorAll('input[type="checkbox"]:checked');
      checkedInputs.forEach((input) => {
        const name = input.name;
        if (!filterData.filters[name]) {
          filterData.filters[name] = [];
        }
        filterData.filters[name].push(input.value);
      });

      // Collect price range values
      const minPriceInput = form.querySelector('.mobile-price-facet__input[name*="gte"]');
      const maxPriceInput = form.querySelector('.mobile-price-facet__input[name*="lte"]');
      if (minPriceInput && minPriceInput.value) {
        filterData.priceRange.min = minPriceInput.value;
        filterData.priceRange.minName = minPriceInput.name;
      }
      if (maxPriceInput && maxPriceInput.value) {
        filterData.priceRange.max = maxPriceInput.value;
        filterData.priceRange.maxName = maxPriceInput.name;
      }

      // Store filter data in sessionStorage
      sessionStorage.setItem(`mobile-filter-data`, JSON.stringify(filterData));
    }

    const mobileFacetsForm = popup.querySelector('facets-form-component');
    if (mobileFacetsForm?.updateFilters) mobileFacetsForm.updateFilters();
  }

  function handleSortRadioChange(popup, event) {
    if (event.target.type === 'radio' && event.target.name === 'sort_by') {
      updateSortWithFilters(popup);
    }
  }

  function updateSortWithFilters(popup) {
    const section = popup.closest('.shopify-section');
    if (!section) return;

    // Get section ID to build the exact form ID
    const sectionId = section.id;
    if (!sectionId) return;

    // Try to find the desktop form by exact ID pattern: FacetFiltersForm--{sectionId}-desktop
    const desktopFormId = `FacetFiltersForm--${sectionId}-desktop`;
    let desktopForm = section.querySelector(`form#${desktopFormId}`);

    // If not found, try partial match
    if (!desktopForm) {
      desktopForm = section.querySelector('form[id*="desktop"]:not([id*="mobile"]):not([id*="overflow"])');
    }

    // Get the facets-form-component that contains this form
    let mainFacetsForm = null;
    if (desktopForm) {
      mainFacetsForm = desktopForm.closest('facets-form-component');
    }

    // Fallback: try to find facets-form-component by ID (works for horizontal)
    if (!mainFacetsForm) {
      mainFacetsForm =
        section.querySelector('facets-form-component[id*="desktop"]') ||
        section.querySelector('facets-form-component[id*="overflow"]');
    }

    if (!mainFacetsForm) return;
    const sortForm = popup.querySelector('form');
    const checkedRadio = sortForm?.querySelector('input[name="sort_by"]:checked');
    const sortBy = checkedRadio?.value;
    if (!sortBy) return;
    const mainForm = mainFacetsForm.querySelector('form');
    if (!mainForm) return;
    const formId = mainForm.id;
    mainForm.querySelectorAll('input[name="sort_by"]').forEach((input) => input.remove());
    if (formId) {
      document.querySelectorAll(`input[name="sort_by"][form="${formId}"]`).forEach((input) => {
        input.checked = false;
        input.removeAttribute('form');
      });
    }
    const sortInput = Object.assign(document.createElement('input'), {
      type: 'hidden',
      name: 'sort_by',
      value: sortBy,
    });
    mainForm.appendChild(sortInput);
    const originalCreateURLParameters = mainFacetsForm.createURLParameters.bind(mainFacetsForm);
    mainFacetsForm.createURLParameters = function (formData) {
      const params = originalCreateURLParameters(formData);
      params.delete('sort_by');
      params.set('sort_by', sortBy);
      return params;
    };
    if (mainFacetsForm.updateFilters) mainFacetsForm.updateFilters();
    setTimeout(() => {
      if (formId) {
        document.querySelectorAll(`input[name="sort_by"]:not([form])`).forEach((input) => {
          if (input.closest('sorting-filter-component')) input.setAttribute('form', formId);
        });
      }
      mainFacetsForm.createURLParameters = originalCreateURLParameters;
    }, 100);
  }

  function handleFilterUpdate(popup) {
    setTimeout(() => {
      if (popup.refs.dialog?.open) popup.closeDialog();
    }, 300);
  }

  function handleCategoryClick(event) {
    const categoryButton = event.target.closest('.mobile-filter-layout__category');
    if (!categoryButton) return;
    const filterIndex = categoryButton.dataset.filterIndex;
    const popup = categoryButton.closest('mobile-filter-popup');
    if (!popup) return;
    popup
      .querySelectorAll('.mobile-filter-layout__category')
      .forEach((btn) => btn.classList.remove('mobile-filter-layout__category--active'));
    categoryButton.classList.add('mobile-filter-layout__category--active');
    popup
      .querySelectorAll('.mobile-filter-layout__options-panel')
      .forEach((panel) => panel.classList.remove('mobile-filter-layout__options-panel--active'));
    const activePanel = popup.querySelector(`.mobile-filter-layout__options-panel[data-filter-index="${filterIndex}"]`);
    if (activePanel) activePanel.classList.add('mobile-filter-layout__options-panel--active');

    // Store active filter index when category is clicked
    sessionStorage.setItem(`mobile-filter-active-index`, filterIndex);
  }

  initializeDialogs();
  document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
  document.addEventListener('click', handleCategoryClick);

  function defineMobileFilterPopup(DialogComponent) {
    if (customElements.get('mobile-filter-popup')) return;
    class MobileFilterPopup extends DialogComponent {
      constructor() {
        super();
        this.handleDialogCloseBound = handleDialogClose.bind(null, this);
      }
      connectedCallback() {
        super.connectedCallback();
        this.style.display = 'none';
        this.addEventListener('dialog:close', this.handleDialogCloseBound);
      }
      showDialog() {
        this.style.display = 'block';
        super.showDialog();
      }
      async closeDialog() {
        await super.closeDialog();
        this.style.display = 'none';
      }
      resetFilters() {
        resetFilterCheckboxes(this);
      }
      applyFilters() {
        console.log('applyFilters');
        applyFilterChanges(this);
      }
    }
    customElements.define('mobile-filter-popup', MobileFilterPopup);
  }

  function defineMobileSortPopup(DialogComponent) {
    if (customElements.get('mobile-sort-popup')) return;
    class MobileSortPopup extends DialogComponent {
      constructor() {
        super();
        this.handleFilterUpdateBound = handleFilterUpdate.bind(null, this);
        this.handleSortChangeBound = handleSortRadioChange.bind(null, this);
        this.handleDialogCloseBound = handleDialogClose.bind(null, this);
      }
      connectedCallback() {
        super.connectedCallback();
        this.style.display = 'none';
        this.addEventListener('dialog:close', this.handleDialogCloseBound);
        document.addEventListener('filter:update', this.handleFilterUpdateBound);
        const form = this.querySelector('form');
        if (form) form.addEventListener('change', this.handleSortChangeBound);
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('filter:update', this.handleFilterUpdateBound);
      }
      showDialog() {
        this.style.display = 'block';
        super.showDialog();
      }
      async closeDialog() {
        await super.closeDialog();
        this.style.display = 'none';
      }
    }
    customElements.define('mobile-sort-popup', MobileSortPopup);
  }

  function registerCustomElements() {
    const DialogComponent = customElements.get('dialog-component');
    if (DialogComponent) {
      defineMobileFilterPopup(DialogComponent);
      defineMobileSortPopup(DialogComponent);
    } else {
      customElements.whenDefined('dialog-component').then(() => {
        defineMobileFilterPopup(customElements.get('dialog-component'));
        defineMobileSortPopup(customElements.get('dialog-component'));
      });
    }
  }

  registerCustomElements();
  } catch(e) { console.error(e); }
})();

})();
